module.exports = __webpack_public_path__ + "img/profil.087714d6.svg";